import { useElementInView } from 'front-commons/hooks';
import { useCallback, useEffect, useState } from 'react';
import useCustomer from 'stores/customer';
import useDrawer from 'stores/drawer';

const Window = window as any;

export function useZendesk() {
	const {
		customerStore: { data },
	} = useCustomer();

	const { isAnyDrawerOpen } = useDrawer();

	const [isZendeskOpen, setIsZendeskOpen] = useState(false);

	const isFooterVisible = useElementInView('[data-testid="page-footer"]');
	const isAnyDialogVisible = useElementInView('[data-testid="dialog-overlay"]');

	useEffect(() => {
		document.documentElement.style.setProperty(
			'--zendesk-footer-offset',
			isFooterVisible ? 'var(--footer-height, 0px)' : '0px',
		);

		return () => {
			document.documentElement.style.removeProperty('--zendesk-footer-offset');
		};
	}, [isFooterVisible]);

	useEffect(() => {
		if (isAnyDialogVisible) {
			closeZendesk();
		}
	}, [isAnyDialogVisible]);

	useEffect(() => {
		if (isAnyDrawerOpen) {
			closeZendesk();
			hideZendesk();
			return;
		}

		showZendesk();
	}, [isAnyDrawerOpen]);

	useEffect(() => {
		Window.zE('messenger:ui', 'newConversation', {
			displayName: 'Technical Support',
		});

		Window.zE('messenger:set', 'customization', {
			theme: {
				primary: '#1D58D8',
				onPrimary: '#FFFFFF',
				action: '#2556B1',
				onAction: '#F2F2F2',
			},
			common: {
				contentScale: 110,
			},
			position: {
				offset: {
					web: { horizontal: 32, vertical: 24 },
					mobile: { horizontal: 16, vertical: 16 },
				},
			},
		});
	}, []);

	useEffect(() => {
		if (!data?.id) {
			Window.zE('messenger', 'resetWidget', () => {
				console.log('You have reset the messaging Web Widget');
			});

			Window.zE('messenger', 'hide');

			return;
		}

		Window.zE(
			'messenger',
			'updateUser',
			{
				name: data.name,
				email: data.email,
			},
			() => {
				console.log('User updated');
			},
		);

		Window.zE('messenger', 'show');
	}, [data]);

	useEffect(() => {
		Window.zE('messenger:on', 'open', () => {
			setIsZendeskOpen(true);
		});

		Window.zE('messenger:on', 'close', () => {
			setIsZendeskOpen(false);
		});
	}, []);

	const openZendesk = useCallback(() => {
		Window.zE('messenger', 'open');
	}, []);

	const closeZendesk = useCallback(() => {
		Window.zE('messenger', 'close');
	}, []);

	const showZendesk = useCallback(() => {
		Window.zE('messenger', 'show');
	}, []);

	const hideZendesk = useCallback(() => {
		Window.zE('messenger', 'hide');
	}, []);

	const toggleZendesk = useCallback(() => {
		if (isZendeskOpen) {
			closeZendesk();
		} else {
			openZendesk();
		}
	}, [isZendeskOpen, closeZendesk, openZendesk]);

	return {
		isZendeskOpen,
		openZendesk,
		closeZendesk,
		showZendesk,
		hideZendesk,
		toggleZendesk,
	};
}
